let isCustomCodeExecuted = false;

document.addEventListener('consentmoSignal_onLoad', function(eventData) {
  const csmLoadSignal = eventData.detail || { isActive: false };
  if (!csmLoadSignal.isActive) {
    executeCustomCode();
  } else {
    document.addEventListener('consentmoSignal', function(event) {
      const csmSignal = event.detail;
      const csmPreferences = csmSignal.preferences;
      if (csmPreferences.analytics && csmPreferences.marketing && csmPreferences.functionality) {
        executeCustomCode();
      }
    });
  }
});

function executeCustomCode() {
  if (!isCustomCodeExecuted) {
    initHyInstagram();
    isCustomCodeExecuted = true;
  }
}

function initHyInstagram() {
  let elements = document.querySelectorAll("[data-hy-instagram-feed]");
  if (elements.length > 0) {
    elements.forEach((v) => {
        v.src = v.dataset.src;
        v.parentElement.classList.add("elfsight-loaded");
    });
  }
}